import React from "react";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import LimitedAccessRoute from "./components/LimitedAccessRoute"; // 追加
import "./utils/clearAuth"; // デバッグ用
import HomePage from "./pages/HomePage-v2";
import SentenceViewerPage from "./pages/SentenceViewerPage";
import SentenceViewerJ2Page from "./pages/SentenceViewerJ2Page";
import PassageViewerJ2Page from "./pages/PassageViewerJ2Page";
import Ex2ViewerPage from "./pages/Ex2ViewerPage";
import CameraUploaderPage from "./pages/CameraUploaderPage";
import FileUploaderPage from "./pages/FileUploaderPage";
import WordViewerPage from "./pages/WordViewerPage";
import WordViewerJ2Page from "./pages/WordViewerJ2Page";
import WordsMatchingCheckerPage from "./pages/WordsMatchingCheckerPage";
import WorksheetMakerPage from "./pages/WorksheetMakerPage";
import WorksheetEditorPage from "./pages/WorksheetEditorPage";
import WorksheetPrintGuidePage from "./pages/WorksheetPrintGuidePage";
import SkitViewerPage from "./pages/SkitViewerPage";
import HomeworkPage from "./pages/HomeworkPage";
import PlayLogPage from "./pages/PlayLogPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminV2App from "./admin-v2/AdminV2App";
import LoginPage from "./pages/LoginPage";
import KeybordPage from "./pages/KeybordPage";
import HomeworkWordsPage from "./pages/HomeworkWordsPage";
import IrregularVerbsPage from "./pages/IrregularVerbsPage";
import PronunciationLabPage from "./pages/PronunciationLabPage";
import PronunciationLessonPage from "./pages/PronunciationLessonPage";
// import MangaPage from "./pages/MangaPage"; // 現在未使用のため無効化
import J2TextRegisterPage from "./pages/J2TextRegisterPage";
import WordGenJ2Page from "./pages/WordGenJ2Page";

function App() {
  const isDev = process.env.NODE_ENV === "development";
  const API_BASE = isDev ? "http://localhost:8000" : "/api";
  const AUDIO_BASE = isDev ? "http://localhost:8000" : "";

  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* 一般公開 */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/worksheet_print_guide" element={<WorksheetPrintGuidePage />} />
          <Route path="/sentence_viewer" element={<PrivateRoute><SentenceViewerPage API_BASE={API_BASE} AUDIO_BASE={AUDIO_BASE} /></PrivateRoute>} />
          <Route path="/sentence_viewer_j2" element={<PrivateRoute><SentenceViewerJ2Page API_BASE={API_BASE} AUDIO_BASE={AUDIO_BASE} /></PrivateRoute>} />
          <Route path="/passage_viewer_j2" element={<PrivateRoute><PassageViewerJ2Page API_BASE={API_BASE} AUDIO_BASE={AUDIO_BASE} /></PrivateRoute>} />
          <Route path="/ex2_viewer" element={<PrivateRoute><Ex2ViewerPage API_BASE={API_BASE} AUDIO_BASE={AUDIO_BASE} /></PrivateRoute>} />
          <Route path="/word_viewer" element={<PrivateRoute><WordViewerPage API_BASE={API_BASE} AUDIO_BASE={AUDIO_BASE} /></PrivateRoute>} />
          <Route path="/word_viewer_j2" element={<PrivateRoute><WordViewerJ2Page API_BASE={API_BASE} AUDIO_BASE={AUDIO_BASE} /></PrivateRoute>} />
          <Route path="/skit_viewer" element={<PrivateRoute><SkitViewerPage API_BASE={API_BASE} AUDIO_BASE={AUDIO_BASE} /></PrivateRoute>} />
          <Route path="/homework" element={<PrivateRoute><HomeworkPage API_BASE={API_BASE} /></PrivateRoute>} />
          <Route path="/irregular_verbs" element={<PrivateRoute><IrregularVerbsPage API_BASE={API_BASE} AUDIO_BASE={AUDIO_BASE} /></PrivateRoute>} />
          <Route path="/homework_words" element={<PrivateRoute><HomeworkWordsPage API_BASE={API_BASE} /></PrivateRoute>} />
          <Route path="/keyboard" element={<PrivateRoute><KeybordPage /></PrivateRoute>} />
          {/* <Route path="/manga" element={<PrivateRoute><MangaPage API_BASE={API_BASE} /></PrivateRoute>} /> 現在未使用のため無効化 */}

          {/* 限定公開 */}
          <Route path="/pronunciation_lab" element={<LimitedAccessRoute><PronunciationLabPage API_BASE={API_BASE} AUDIO_BASE={AUDIO_BASE} /></LimitedAccessRoute>} />
          <Route path="/pronunciation_lesson" element={<LimitedAccessRoute><PronunciationLessonPage API_BASE={API_BASE} AUDIO_BASE={AUDIO_BASE} /></LimitedAccessRoute>} />
          <Route path="/play_log" element={<LimitedAccessRoute><PlayLogPage API_BASE={API_BASE} /></LimitedAccessRoute>} />

          {/* ローカル専用 */}
          {isDev && (
            <>
              <Route path="/worksheet_maker" element={<PrivateRoute><WorksheetMakerPage /></PrivateRoute>} />
              <Route path="/worksheet_editor/:id" element={<PrivateRoute><WorksheetEditorPage /></PrivateRoute>} />
              <Route path="/words_matching_chacker" element={<PrivateRoute><WordsMatchingCheckerPage /></PrivateRoute>} />
              <Route path="/camera" element={<PrivateRoute><CameraUploaderPage /></PrivateRoute>} />
              <Route path="/uploader" element={<PrivateRoute><FileUploaderPage /></PrivateRoute>} />
              <Route path="/j2_register" element={<PrivateRoute><J2TextRegisterPage /></PrivateRoute>} />
              <Route path="/word_gen_j2" element={<PrivateRoute><WordGenJ2Page API_BASE={API_BASE} AUDIO_BASE={AUDIO_BASE} /></PrivateRoute>} />
              <Route path="/admin" element={<PrivateRoute><AdminDashboardPage /></PrivateRoute>} />
              <Route path="/admin-v2/*" element={<PrivateRoute><AdminV2App /></PrivateRoute>} />
            </>
          )}
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
